import { InjectionToken } from '@angular/core';

export const ENVIRONMENT_CONFIG = new InjectionToken<EnvironmentConfig>(
  'environmentConfig',
);

export interface EnvironmentConfig {
  production: boolean;
  oidc: {
    clientId: string;
    redirectUri: string;
    metadataUri: string;
    authorizeUri: string;
    secureUris: string[];
    noRefreshUris: string[];
    publicUris: string[];
  };
  api: {
    gateways: {
      cdn: string;
      secureApi: string;
      publicApi: string;
      gsgPublicApi: string;
      gsgSecureApi: string;
    };
    proxy: {
      headers: {
        [header: string]: string;
      };
    };
    searchIndex: string;
    salesDemo: boolean;
  };
  sessionTimeoutPopup: {
    timeoutDuration: number;
    logoutDuration: number;
    keepAliveUrl: string;
  };
  trustId: string;
  features: FeatureToggles;
}

export const CDN_BASE_URL = new InjectionToken<string>('CDN_BASE_URL');

export type Feature =
  | 'nextRelease' // dont remove me :)
  | 'trust'
  | 'patientOldView'
  | 'patientEnhBehavior'
  | 'patientEnhDentalFacets'
  | 'precertAppeal'
  | 'precertManual'
  | 'precertDg'
  | 'precertAppealDental'
  | 'pdlViewer'
  | 'dashboardNewFeatures'
  | 'emailVerifyPopup'
  | 'mfaVerify'
  | 'mfaWamTool'
  | 'mfaLogin'
  | 'reconAppealsEnhanced'
  | 'claimSupportInfo'
  | 'claimsRecon'
  | 'claimsReconDental'
  | 'reconBanner'
  | 'overPaidClaimsInfo'
  | 'multiMatchFlaggedClaim';

export type FeatureToggles = Record<Feature, boolean>;
